import { render } from "./create_orcaa.html?vue&type=template&id=5aa0ce39&external"
import script from "./create_orcaa.js?vue&type=script&lang=js&external"
export * from "./create_orcaa.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__